module.exports = __webpack_public_path__ + "img/close_music.24391ceb.svg";